module.exports = __webpack_public_path__ + "img/servipag_xl.4ca0297c.svg";